export default __webpack_public_path__ + "static/media/ingles-en-serio-madera6859-optimized.5c84f755.jpg";